import { V3Record } from 'data/helpers/V3Record.js'

export const SegmentMatch = V3Record('segmentMatch', {
  createdAt: null,
  updatedAt: null,
  segmentId: null,
  distance: null,
  duration: null,
  avgSpeed: null,
  rank: null,
  eleGain: null,
  grade: null,
  segmentTitle: null,
  parentType: null,
  parentId: null,
  startIndex: null,
  endIndex: null,
  personalRecord: null
})
